import { createUseStyles } from 'react-jss';
import { CmsWrenchTheme } from '~app/styles/cmsTheme';

const useStyle = createUseStyles(({ breakpoints, brandColors }: CmsWrenchTheme) => {
  const mediaQueryMinScreenMD = `@media (min-width: ${breakpoints.md}px)`;

  return {
    mainGrid: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      marginBottom: '20px',
      [mediaQueryMinScreenMD]: {
        flexDirection: 'row',
      },
    },

    pageContent: {
      backgroundColor: brandColors.neutral.smoke,
    },
    pathImage: {
      marginLeft: '10px',
      width: '240px',
      height: '205px',
      objectFit: 'contain',
      marginTop: '20px',
    },
  };
});

export default useStyle;
